export default __webpack_public_path__ + "static/media/image 11.071ae9ad.png";